export default {
  billing: {
    bannerDescription:
      'Some of the data below was generated from your previous enrollment in the Coin Network (which has been deactivated).<br/>To continue using these features <b>please upgrade your program.</b>'
  },
  customerCenter: {
    overview: {
      title: 'Customer center',
      description:
        'Every customer, transaction, reward and insights to help your business grow.',
      cards: {
        totalCustomers: {
          title: 'Total customers',
          description:
            'Total number of customers signed up for this reporting period.'
        },
        totalActives: {
          title: 'Active customers',
          description:
            'Total customers that’ve interacted with your program in the last {numberOfDays} {pluralDays}.'
        },
        totalInactives: {
          title: 'Inactive customers',
          description:
            'Customers who have not interacted with your program within the last {numberOfDays} {pluralDays}.'
        },
        totalSales: {
          title: 'Total transactions',
          description:
            'Number of transaction made by customers in your store for this reporting period.'
        },
        totalReferrals: {
          title: 'Total referrals',
          description:
            'Total number of referrals your customers have created to your business.'
        },
        totalRewards: {
          title: 'Rewarded Coins',
          description:
            'Total number of Coins that have been minted and issued as a reward for a purchase.'
        },
        totalRedeemed: {
          title: 'Redeemed Coins',
          description:
            'Total number of Coins used by your customers during their transactions.'
        }
      }
    },
    customersList: {
      title: 'Customer relationships',
      description:
        'A complete, automated and growing list of your customers with information that enables you to know who they really are.'
    }
  },
  customerCenterV2: {
    overview: {
      title: 'Members',
      description:
        'Every member, transaction, reward and insights to help your business grow.',
      cards: {
        totalCustomers: {
          title: 'Total Members',
          description:
            'Number of members enrolled in the loyalty program, showing the program’s reach.'
        },
        memberEngagement: {
          title: 'Active Members Engagement',
          description:
            'Percentage of active members with more than one interaction in your campaigns.'
        },
        totalActives: {
          title: 'Active Members',
          description:
            'Total members that’ve interacted with your program in the last {numberOfDays} {pluralDays}.'
        },
        totalInactives: {
          title: 'Inactive Members',
          description:
            'Members who have not interacted with your program within the last {numberOfDays} {pluralDays}.'
        }
      }
    },
    customersList: {
      title: 'Member relationships',
      description:
        'A complete, automated and growing list of your members with information that enables you to know who they really are.'
    }
  },
  transactionsCenter: {
    title: 'Loyalty Coins',
    subtitle:
      'Effortlessly monitor the spending patterns of your most loyal customers and stay updated on the latest activity of your Loyalty Rewards Program.',
    transactionList: {
      title: 'Customers activity',
      description:
        'An up-to-date feed showing the latest activity customers are generating with your Loyalty Reward Program.'
    }
  },
  activities: {
    overview: {
      title: 'Activity',
      description:
        'Track daily activities for all your active campaigns and members.'
    },
    totalSpend: {
      title: 'Member spending activity',
      description: 'Amount spent by your loyal members in your store',
      cards: {
        revenue: {
          label: 'Over time',
          tooltipText:
            'The sum of all purchases made by loyal members in your store from the time you installed Twism to today.'
        },
        lastMonthRevenue: {
          label: 'Last month',
          tooltipText: ''
        },
        thisMonthRevenue: {
          label: 'This month',
          tooltipText: ''
        }
      },
      bottomBtn: {
        titleClosed: 'See more details',
        titleOpened: 'See less details'
      },
      spendOverTime: {
        title: 'Members spend over time',
        cards: {
          customerSpend: {
            description: 'Members spend for the<br />selected time period',
            tooltipText:
              'Amount spent by loyal members in your store for the selected period'
          }
        },
        graphic: {
          titleChart: 'Member Spend chart',
          legendGATracking: 'Legend',
          periodGATracking: 'Period',
          labelLegendGraphic: 'spend'
        }
      }
    },
    campaignActivity: {
      title: 'Campaigns activity',
      description:
        'Gain insights and track daily activities for all your active campaigns.',
      tabs: {
        loyaltyRewards: {
          title: 'Loyalty Program',
          rewardedCoins: {
            tooltip:
              'Total number of Coins that your <br />business rewarded to members <br />after a transaction.'
          },
          rewardedCustomers: {
            tooltip:
              'Number of members that <br />received rewards from your<br /> business.'
          },
          pendingCoins: {
            tooltip:
              'Total number of Coins which are not <br />yet released to members due to <br />your Refund Policy settings.<br /> (Value referring to the current<br /> moment and not the selected <br />period)'
          },
          loyaltyRevenue: {
            tooltip:
              'The sum of all transactions made by <br />members acquired from your <br />reward program.'
          }
        },
        welcomeCoinsCampaigns: {
          title: 'Welcome Coins campaigns',
          coinsClaimed: {
            tooltip:
              'Total amount of welcome Coins claimed<br /> by existing and new members.'
          },
          customersWhoClaimed: {
            tooltip: 'Total number of members that<br /> claimed welcome Coins.'
          },
          customerLimit: {
            tooltip:
              'Shows the member limit of the<br /> campaign, and how many have<br /> claimed already.'
          },
          customerLimitTotal: {
            tooltip:
              'Number of members that collected <br />your welcome Coins campaign and the <br />member total limit set for this <br />campaign.'
          }
        },
        referralProgram: {
          title: 'Referral program',
          totalReferrals: {
            tooltip:
              'Number of referral program links<br /> generated for your business by <br />members.'
          },
          newCustomers: {
            tooltip:
              'Number of new members who signed up to your reward program using a referral program<br /> link.'
          },
          customersPurchases: {
            tooltip:
              'Number of new members who <br />made a qualified purchase using a<br /> referral program link.'
          },
          revenue: {
            tooltip:
              'The sum of all transactions <br />generated by members that came <br />from a referral program link.'
          }
        },
        dealsDiscounts: {
          title: 'Deals & discounts',
          offerViews: {
            tooltip:
              'Total number of times your offers  <br />have been viewed.'
          },
          savedOffer: {
            tooltip:
              'Number of times your offers have <br /> been claimed, but not redeemed.'
          },
          redeemedOffer: {
            tooltip:
              'Number of offers that have been  <br />redeemed by your members.'
          },
          revenue: {
            tooltip:
              'A sum of all transactions that used <br /> a redeemed offer.'
          }
        },
        birthdayClub: {
          title: 'Birthday club',
          offerViews: {
            tooltip:
              'Total number of times your birthday<br /> offer has been viewed.'
          },
          savedOffer: {
            tooltip:
              'Number of times your birthday offer <br />has been claimed, but not <br />redeemed.'
          },
          redeemedOffer: {
            tooltip:
              'Number of birthday offers that have <br />been redeemed by your members.'
          },
          revenue: {
            tooltip:
              'A sum of all transactions that used a <br />redeemed birthday offer.'
          }
        },
        specialCoins: {
          title: 'Offers',
          offerViews: {
            tooltip:
              'Total number of times your offers  <br />have been viewed.'
          },
          savedOffer: {
            tooltip:
              'Number of times your offers have <br /> been claimed, but not redeemed.'
          },
          redeemedOffer: {
            tooltip:
              'Number of offers that have been  <br />redeemed by your members.'
          },
          revenue: {
            tooltip:
              'A sum of all transactions that used <br /> a redeemed offer.'
          }
        },
        giftCardsCoins: {
          title: 'Sell Coins',
          coinsSold: {
            tooltip: 'Total number of Coins sold.'
          },
          coinsAwarded: {
            tooltip:
              'Total number of Coins awarded by <br />you to your members.'
          },
          coinsGifted: {
            tooltip: 'Total number of Coins sent between <br />members.'
          },
          coinsRedeemed: {
            tooltip: 'Total number of sent Coins that <br />were redeemed.'
          },
          revenue: {
            tooltip:
              'A sum of all transactions that used <br />Coins sent between members.'
          }
        }
      }
    },
    list: {
      title: 'Member activity',
      description:
        'An up-to-date feed showing the activites your members are generating on a daily basis. Filter by campaign type and access members profiles.'
    }
  },
  conversions: {
    list: {
      title: 'Conversions',
      description:
        'Monitor any conversion event for your business. Typically this means a customer has engaged with one of your incentive campaigns.'
    }
  },
  redemptions: {
    title: 'Redemptions',
    description:
      'Monitor conversion events for your business. (When a member has engaged with one of your campaigns).',
    overview: {
      title: 'Overview',
      cards: {
        offer: {
          totalRedemptions: {
            label: 'Total Offers Redemptions',
            description:
              'Total number of times members have redeemed your offers.'
          },
          paymentRelatedToRedemptions: {
            label: 'Revenue from Redemptions',
            description:
              'Estimated financial value generated when members use their Offers.'
          },
          averagePaymentRelatedToRedemptions: {
            label: 'Average Spend per Redemption',
            description:
              'Estimated amount spent by members when using Offers by the program.'
          }
        },
        'offer-coins': {
          totalRedemptions: {
            label: 'Total Redemptions',
            description:
              'Total number of times members have redeemed offers or coins at your store.'
          },
          paymentRelatedToRedemptions: {
            label: 'Revenue from Redemptions',
            description:
              'Estimated financial value generated when members use their Coins or Offers.'
          },
          averagePaymentRelatedToRedemptions: {
            label: 'Average Spend per Redemption',
            description:
              'Estimated amount spent by members when using Offers and Coins offered by the program.'
          }
        },
        coin: {
          totalRedemptions: {
            label: 'Total Coins Redemptions',
            description:
              'Total number of times members have redeemed coins at your store.'
          },
          paymentRelatedToRedemptions: {
            label: 'Payments related to transactions',
            description:
              'Estimated financial value generated when members use their Coin.'
          },
          averagePaymentRelatedToRedemptions: {
            label: 'Average Spend per Redemption',
            description:
              'Estimated amount spent by members when using Coins offered by the program.'
          }
        }
      }
    },
    overtime: {
      title: 'Redemptions Over Time'
    },
    list: {
      title: 'Redemption Activity',
      description: {
        default:
          'Monitor and manage all members redemptions from your campaigns. Review each instance where members redeemed Offers or Coins.',
        dontHaveAccessOffers:
          'Monitor and manage all members redemptions from your campaigns. Review each instance where members redeemed Coins.'
      }
    }
  },
  overview: {
    overview: {
      title: 'Overview',
      subtitle:
        'A quick snapshot of the health of your members and the activity of your initiatives.',
      cards: {
        totalCustomers: {
          label: 'Total Members',
          description: 'Number of members enrolled in your program.'
        },
        activeCustomers: {
          label: 'Active Members',
          description:
            'Number of members who have interacted with offers within a specific period (e.g., last {numberOfDays} {pluralDays}).'
        },
        paymentRelatedToRedemptions: {
          label: 'Payments Related to Redemptions',
          description:
            'Estimated financial value generated when members use their Coins or redeem offers.'
        },
        totalNoMembersReached: {
          label: 'Non-Members Reached',
          description:
            "Total number of non-members who were exposed to the business's brand within the Twism ecosystem."
        },
        totalOfferRedemptions: {
          label: 'Total Offer Redemptions',
          description:
            'Total number of times members have redeemed your offers.'
        },
        redeemedCoins: {
          label: 'Total Coins Redeemed',
          description:
            'Total number of Coins that have been redeemed by members of your loyalty program.'
        },
        impressions: {
          label: 'Business Impressions',
          description:
            'Number of times the business or its offers were displayed to members. This could include views on the Twism app.'
        }
      }
    },
    customerGrowth: {
      title: 'Customer growth',
      subtitle:
        'Get a quick snapshot of how active campaigns, rewards, and offers are generating daily acitivity for your business.',
      analytics: {
        newCustomers: {
          tooltip:
            'New customers that have interacted with your business within the selected period.'
        },
        returningCustomers: {
          tooltip:
            'Customers who’ve made a purchase at your business and returned within the selected period.'
        },
        transactions: {
          tooltip:
            'Total number of transactions completed and related to the time period selected.'
        }
      }
    },
    memberGrowth: {
      title: 'Member growth',
      subtitle: {
        offer:
          'Get a quick snapshot of how active campaigns, rewards, and offers are generating daily activity for your business.',
        'offer-coins':
          'Get a quick snapshot of how active campaigns, rewards, and offers are generating daily activity for your business.',
        coin:
          'Get a quick snapshot of how active campaigns and rewards are generating daily activity for your business.'
      },
      analytics: {
        newCustomers: {
          tooltip:
            'New members that have interacted with your business within the selected period.'
        },
        returningCustomers: {
          tooltip:
            'Members who’ve made a purchase at your business and returned within the selected period.'
        },
        transactions: {
          tooltip:
            'Total number of transactions completed and related to the time period selected.'
        }
      }
    },
    coinsReports: {
      analytics: {
        rewardedCoins: {
          description: 'Rewarded Coins',
          tooltip: 'Coins earned by customers from <br />qualifying purchases.'
        },
        purchasedCoins: {
          description: 'Purchased Coins',
          tooltip:
            'Coins purchased by customers to<br /> use later or as gifts for friends and <br />family.'
        },
        freeCoins: {
          description: 'Free Coins minted',
          tooltip:
            'Total number of free Coins minted<br /> from campaigns in the selected time<br /> period.'
        },
        welcomeCoins: {
          description: 'Welcome Coins minted',
          tooltip:
            'Total number of welcome Coins minted<br /> from campaigns in the selected time<br /> period.'
        },
        tradedCoins: {
          description: 'Traded Coins',
          tooltip:
            'The sum of all Coins that have been<br /> sent to other people from your<br /> existing members.'
        }
      }
    }
  },
  memberDetail: {
    reports: {
      totalRedemptions: {
        tooltip: 'Number of offers redeemed by members.'
      },
      totalSavedOffer: {
        tooltip:
          'Total number of offers that have been saved by members, available for future use.'
      },
      totalRedeemedOffer: {
        tooltip: 'Number of offers that have been redeemed and utilized.'
      },
      lifetimeCoins: {
        tooltip:
          'Total amount accumulated since the member started using Twism.'
      },
      redeemedCoins: {
        tooltip:
          'Number of coins that the member received from loyalty rewards.'
      },
      averageSpent: {
        tooltip:
          'The average amount spent by this member per purchase in your store from the time you installed Twism to today.'
      },
      totalSpent: {
        tooltip:
          'The sum of all purchases made by this member in your store from the time you installed Twism to today.'
      }
    }
  }
};
